import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { InvoiceService } from "../../invoice.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import moment from "moment";
import nationsWithCodes from "../../../../auth/models/nations-with-codes";

@Component({
  selector: "app-invoice-modal-detail",
  templateUrl: "./invoice-modal-detail.component.html",
  styles: [""]
})
export class InvoiceModalDetailComponent implements OnInit {
  @Input() invoiceId: number;
  @Output() onclose: EventEmitter<any> = new EventEmitter();
  @ViewChild("invoiceModalDetail") modal: any;

  invoice: any;
  months = moment.months();

  constructor(private _modalService: NgbModal, private _invoiceService: InvoiceService, public _utilsService: UtilsService) {
  }

  ngOnInit(): void {
    this._invoiceService.get(this.invoiceId).subscribe((invoice: any) => {
      if (invoice) {

        if (!!invoice.order_child_id) {
          invoice.order = invoice.orders_child.find((orderChild: any) => orderChild.id == invoice.order_child_id);
        }

        if (invoice.client?.head_office?.external) {
          const country = invoice.client?.head_office?.country;
          invoice.client.head_office.country_name = nationsWithCodes.find((c: any) => c.code == country)?.name;
        }

        this.invoice = invoice;
        this._modalService.open(this.modal, {
          centered: true,
          size: "xl",
          backdrop: false,
          keyboard: false
        });
      } else {
        this._utilsService.showToastrError("INVOICE_NOT_FOUND");
        this.onclose.emit();
      }
    });
  }

  closeModal() {
    this._modalService.dismissAll();
    this.onclose.emit();
  }

}
